import { render, staticRenderFns } from "./Order3DFileUpload.vue?vue&type=template&id=5e22e10f"
import script from "./Order3DFileUpload.vue?vue&type=script&lang=js"
export * from "./Order3DFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports